import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import axios from 'axios';
import dataV from '@jiaminghi/data-view'
Vue.prototype.$axios = axios;

Vue.use(dataV)

new Vue({
  render: h => h(App),
}).$mount('#app')
